import { Injectable, inject } from '@angular/core';
import { RecentlyViewedService } from '@df/catalog-ui/recently-viewed/recently-viewed.service';
import { IRelatedProductsCallback, RelatedProductsService } from '@df/catalog-ui/related-products/related-products.service';
import { Events } from '@df/core/service/event';
import difference from 'lodash-es/difference';
import { RecentlyViewed } from './recently-viewed.interfaces';

@Injectable({
    providedIn: 'root'
})
export class RecentlyViewedEngine {
    /**
     * Recently viewed items service
     */
    private recentService = inject(RecentlyViewedService);
    private events = inject(Events);

    subscribe(cb: () => void) {
        return this.events.on(RecentlyViewed.EVENT).subscribe(() => cb());
    }

    /**
     * models getter
     */
    get(sourceIds: number[], cb: IRelatedProductsCallback) {
        cb(difference(this.recentService.collection, sourceIds || []));
    }

    /**
     * Non cachable - results change all the time
     */
    readonly noCache = true;
}

RelatedProductsService.registerEngine('recent', RecentlyViewedEngine);
